import NewsItemView from '../../../../components/View/NewsItemView/';

export default NewsItemView;